import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------------------------------------------------------------------------
// Suppress the benign "ResizeObserver loop" warning that Radix UI and other
// libraries emit when a layout re-observes itself in the same frame. Chrome
// surfaces it as an "uncaught error" and CRA's dev overlay balloons it into
// a big red modal — but it's harmless, purely a rAF timing quirk. See:
//   https://github.com/WICG/resize-observer/issues/38
//   https://github.com/facebook/create-react-app/issues/11065
// We only swallow this specific message; all other errors still surface.
// ---------------------------------------------------------------------------
const RESIZE_OBSERVER_LOOP_ERR = /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

const swallowResizeObserverError = (e) => {
  const msg = e?.message || e?.reason?.message || '';
  if (RESIZE_OBSERVER_LOOP_ERR.test(msg)) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    return true;
  }
  return false;
};

window.addEventListener('error', swallowResizeObserverError, true);
window.addEventListener('unhandledrejection', swallowResizeObserverError, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
